import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { FormControl, FormHelperText, MenuItem, InputLabel, Select } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  button: {
    display: 'block',
    marginTop: theme.spacing() * 2
  },
  formControl: {
    margin: theme.spacing(),
    minWidth: 120
  }
})

interface MyProps extends StyledProps {
  /** String for the name of the field */
  name: string,
  /** String for the value of the component */
  value?: any,
  /** Object for the select's options */
  options: Array<{}>,
  /** String for the select's label */
  label: string,
  /** Function to be called when the component changes */
  onChange: (e) => void
  /** Boolean indicating whether the field is errored or not */
  error?: boolean
  /** String for field's error text when errored */
  errorText?: string,
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
  /** Object key for menu item label */
  itemLabel: string,
  /** Object key for menu item value */
  itemValue: string
}

export class MultipleSelectInputComponent extends React.Component<MyProps> {
  static defaultProps = {
    disabled:  false,
    onChange:  () => {},
    itemLabel: 'name',
    itemValue: 'value'
  }

  render() {
    const {className, classes, name, value, label, options, itemLabel, itemValue, onChange, error, errorText, disabled} = this.props
    return (
      <FormControl className={classNames(classes.formControl, className)} error={error} aria-describedby={`${name}-error-text`}>
        <InputLabel htmlFor={`${name}-select`}>{label}</InputLabel>
        <Select
          value={value}
          onChange={onChange}
          // options={options}  // Not a valid property
          inputProps={{
            name: name,
            id:   `${name}-select`
          }}
          error={error && !disabled}
          disabled={disabled}
          multiple
        >
          <MenuItem value=''>
            <em>None</em>
          </MenuItem>
          {options.map((option) => <MenuItem key={option[itemLabel]} value={option[itemValue]}> {option[itemLabel] || 'NA'} </MenuItem>)}
        </Select>
        {error && !disabled ? <FormHelperText id={`${name}-error-text`}>{errorText}</FormHelperText> : null}
      </FormControl>
    )
  }
}

@(withStyles as any)(styles)
export class MultipleSelectInput extends MultipleSelectInputComponent{}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/MultipleSelectInput.tsx